import { createTheme } from "@mui/material/styles";
import shadows from "@mui/material/styles/shadows";

shadows["1"] = "0px 8px 24px 0px #1A1D221A";

const theme = createTheme({
  shadows,

  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1280,
      xl: 1440
    }
  },

  palette: {
    primary: {
      main: "#1A99FF",
      contrastText: "#FFFFFF"
    },

    secondary: {
      main: "#292D34",
      contrastText: "#FFFFFF"
    },

    text: {
      primary: "#495057",
      secondary: "#797C8C"
    },

    info: {
      main: "#801AFF"
    },

    grey: {
      "100": "#F6F7F8",
      "200": "#EFF1F4",
      "300": "#E5E7EA",
      "400": "#CED4DA",
      "600": "#797C8C",
      "700": "#54575D",
      "800": "#495057",
      "900": "#21242A"
    },

    background: {
      default: "#FFFFFF",
      paper: "#F6F7F8"
    }
  },

  typography: {
    fontFamily: "Hanken Grotesk",

    body1: {
      color: "#292D34",
      fontSize: "1.5rem",
      fontWeight: 600
    },

    body2: {
      color: "#495057",
      fontSize: "1.125rem",
      fontWeight: 600
    },

    subtitle1: {
      color: "#FFFFFF",
      fontSize: "1.5rem",
      fontWeight: 600
    },

    subtitle2: {
      textTransform: "uppercase",
      color: "#1A99FF",
      paddingBottom: ".25em",
      borderBottom: "solid .25em #1A99FF",
      marginBottom: "1.5em",
      fontSize: "1.125rem",
      fontWeight: 600
    },
    h2: {
      color: "#1A99FF",
      fontSize: "1.5rem",
      lineHeight: "1.803125rem",
      fontWeight: 600
    },
    h3: {
      color: "#292D34",
      fontSize: "1.125rem",
      lineHeight: "1.358125rem",
      fontWeight: 700
    },
    button: {
      fontSize: "1.125rem",
      fontWeight: 600,
      color: "#FFFFFF",
      textTransform: "none"
    }
  }
});

export default theme;
